import React from "react";
import { connect } from "react-redux";
import * as actions from "../../Redux/actions.js"
import { ClaimStatusEnum } from "../../enum.js";
import { getPartnerGuid, hasAuthourity } from "../../../../../lib/access.es6.js";
import ClaimsHeader from "../ClaimsHeader/ClaimsHeader.js";
import ClaimsWrapper from "../ClaimsWrapper/ClaimsWrapper.js";


class HospitalClaims extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      size: 10,
      status: ClaimStatusEnum.docs_pending,
      start_date: '',
      end_date: '',
      type: 'Hospi Cash Illness Benefit',
    };
  }

  componentDidMount() {
    this.getClaimsFiltered();
  }

  getClaimsFiltered(overrides) {
    const merged = Object.assign({
      partner: getPartnerGuid(),
      page: this.state.page,
      size: this.state.size,
      status: this.state.status,
      start_date: this.state.start_date,
      end_date: this.state.end_date,
      type: this.state.type,
    }, overrides || {});

    const stateUpdate = {};
    if (overrides) {
      if (overrides.page !== undefined) stateUpdate.page = overrides.page;
      if (overrides.size !== undefined) stateUpdate.size = overrides.size;
      if (overrides.start_date !== undefined) stateUpdate.start_date = overrides.start_date;
      if (overrides.end_date !== undefined) stateUpdate.end_date = overrides.end_date;
    }
    if (Object.keys(stateUpdate).length > 0) {
      this.setState(stateUpdate);
    }

    this.props.dispatch(actions.getClaimsDcpFilteredRequest(merged));
  }

  getClaimsByStatus(status, callback) {
    this.setState({ status: status, page: 1 }, callback);
  }

  getClaimsByStartDate(start_date) {
    this.setState({ start_date: start_date });
  }

  getClaimsByEndDate(end_date) {
    this.setState({ end_date: end_date });
  }

  handleBulkApproval(payload) {
    this.props.dispatch(actions.bulkApproveRequest(payload));
  }

  render() {
    var claimsResponse = this.props.bulkApprovalData.claims_dcp_filtered || { data: [], page: 1, size: 10, total: 0 };

    if (!hasAuthourity('VIEW_CLAIM')) {
      return <p>You are unauthorized to view claims.</p>;
    }

    return (
      <>
        <ClaimsHeader title="Hospi Cash Illness Dashboard" />
        <ClaimsWrapper
          claimsData={claimsResponse.data || []}
          pagingData={{ page: claimsResponse.page, size: claimsResponse.size, total: claimsResponse.total }}
          type="Hospi Cash Illness Benefit"
          hasAlerts={true}
          hasBulkApprove={true}
          loading={this.props.bulkApprovalData.get_claims_dcp_filtered_loader}
          handleBulkApproval={this.handleBulkApproval.bind(this)}

          showBulkApproveProgressAlert={this.props.bulkApprovalData.bulkApprovalClaimLoader}
          showBulkApproveSuccessAlert={this.props.bulkApprovalData.bulkApprovalClaimSuccess}
          showBulkApproveErrorAlert={!!this.props.bulkApprovalData.bulkApprovalClaimError}
          bulkApproveError={this.props.bulkApprovalData.bulkApprovalClaimError}

          resetBulkApproveSuccessAlert={() => { this.props.dispatch(actions.resetbulkApprovalSuccess()); }}
          resetBulkApproveErrorAlert={() => { this.props.dispatch(actions.resetbulkApprovalFailure()); }}

          getClaimsFiltered={this.getClaimsFiltered.bind(this)}
          getClaimsByStatus={this.getClaimsByStatus.bind(this)}
          getClaimsByStartDate={this.getClaimsByStartDate.bind(this)}
          getClaimsByEndDate={this.getClaimsByEndDate.bind(this)}
        />
      </>
    );
  }
}

export default connect((state) => ({
  bulkApprovalData: state.bulkApprovalData,
}))(HospitalClaims);
